import { render, staticRenderFns } from "./showPDF.vue?vue&type=template&id=6c2e32d2&scoped=true&"
import script from "./showPDF.vue?vue&type=script&lang=js&"
export * from "./showPDF.vue?vue&type=script&lang=js&"
import style0 from "./showPDF.vue?vue&type=style&index=0&id=6c2e32d2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c2e32d2",
  null
  
)

export default component.exports